//Definiremos las constantes globales de la app.
//Vamos a definir la API de strapi
export const API_URL = "https://app-ecommerce-strapi-vue.herokuapp.com";

export const TOKEN = "token";
export const PRODUCTS = "products";